"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _LoadingBlock = require("../../elements/loading-block/LoadingBlock");
var _format = require("../../utils/card/format");
var _cardImageModule = _interopRequireDefault(require("./card-image.module.scss"));
var CardImage = function CardImage(_ref) {
  var isLoading = _ref.isLoading,
    pan = _ref.pan,
    nameOnCard = _ref.nameOnCard,
    expiryDate = _ref.expiryDate,
    cvc = _ref.cvc,
    frontImageUrl = _ref.frontImageUrl,
    backImageUrl = _ref.backImageUrl;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading ? /*#__PURE__*/_react.default.createElement(_LoadingBlock.LoadingBlock, {
    className: _cardImageModule.default['card-image__loading'],
    "data-testid": "loading-card-image"
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: _cardImageModule.default['card-image__container']
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _cardImageModule.default['card-image__number']
  }, pan && (0, _format.formatCardPan)(pan)), /*#__PURE__*/_react.default.createElement("p", {
    className: _cardImageModule.default['card-image__name']
  }, nameOnCard && nameOnCard.toUpperCase()), /*#__PURE__*/_react.default.createElement("p", {
    className: _cardImageModule.default['card-image__date']
  }, expiryDate && (0, _format.formatExpiryDate)(expiryDate)), /*#__PURE__*/_react.default.createElement("img", {
    src: frontImageUrl,
    alt: "front-card",
    className: _cardImageModule.default['card-image__img']
  })), isLoading ? /*#__PURE__*/_react.default.createElement(_LoadingBlock.LoadingBlock, {
    className: _cardImageModule.default['card-image__loading']
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: _cardImageModule.default['card-image__container']
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _cardImageModule.default['card-image__cvc']
  }, cvc), /*#__PURE__*/_react.default.createElement("img", {
    src: backImageUrl,
    alt: "back-card",
    className: _cardImageModule.default['card-image__img']
  })));
};
exports.CardImage = CardImage;